/**
 * @generated SignedSource<<c2ce59284f33242f87ab1697d6e8c9fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type RecommendationAction = "CANCEL" | "INFORM" | "KEEP";
export type SubmitRecommendationInput = {
  bundleId: string;
  cartId: string;
  channel: CartChannel;
  recommendations: ReadonlyArray<Recommendation>;
};
export type Recommendation = {
  action: RecommendationAction;
  recommendationId: string;
};
export type useAddToCartSubmitRecommendationMutation$variables = {
  input: SubmitRecommendationInput;
};
export type useAddToCartSubmitRecommendationMutation$data = {
  readonly submitRecommendation: {
    readonly code: number;
    readonly message: string;
    readonly success: boolean;
  };
};
export type useAddToCartSubmitRecommendationMutation = {
  variables: useAddToCartSubmitRecommendationMutation$variables;
  response: useAddToCartSubmitRecommendationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitRecommendationResponse",
    "kind": "LinkedField",
    "name": "submitRecommendation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddToCartSubmitRecommendationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAddToCartSubmitRecommendationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "04414f627c2c448f458b6b22f15e801d",
    "id": null,
    "metadata": {},
    "name": "useAddToCartSubmitRecommendationMutation",
    "operationKind": "mutation",
    "text": "mutation useAddToCartSubmitRecommendationMutation(\n  $input: SubmitRecommendationInput!\n) {\n  submitRecommendation(input: $input) {\n    code\n    message\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "99b26f77594d66b1b8bdccb177452a4a";

export default node;
